"use client";

import React from "react";
import { Mail, Loader, CircleCheck } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
function NewsletterFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-6 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="w-12 h-12 rounded-lg bg-secondary/20 flex items-center justify-center mb-2">
          <CircleCheck className="w-6 h-6 text-secondary" />
        </div>
        <h4 className="text-xl font-default font-semibold text-foreground">
          Welcome to the neighborhood!
        </h4>
        <p className="text-muted-foreground">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <FormField control={control} name="email" rules={{
      required: "Email address is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Email Address</FormLabel>
            <FormControl>
              <Input type="email" placeholder="your@email.com" className="h-12 text-base bg-background border-border focus-visible:ring-ring rounded-md" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 text-sm text-destructive bg-destructive/10 rounded-md border border-destructive/20">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-base font-default font-semibold bg-primary text-primary-foreground shadow-md hover:shadow-lg transition-all rounded-md">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 w-5 h-5" />
            Joining...
          </> : "Sign Up"}
      </Button>
    </Form>;
}
export default function JoinTheNeighborhood() {
  return <section data-section-id="249958" id="join-the-neighborhood" className="relative py-20 md:py-32 overflow-hidden bg-background">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-xl mx-auto">
          <Card className="bg-card/50 backdrop-blur-sm border-none shadow-xl shadow-shadow-color/5 rounded-2xl">
            <CardHeader className="text-center pb-6 pt-8 px-8">
              <div className="mx-auto w-16 h-16 bg-muted rounded-lg flex items-center justify-center mb-6">
                <Mail className="w-8 h-8 text-secondary" />
              </div>
              <CardTitle className="text-3xl md:text-5xl font-serif font-medium text-foreground mb-3">
                Join the Neighborhood
              </CardTitle>
              <CardDescription className="text-lg text-muted-foreground font-default">
                Get updates on seasonal drinks, fresh pastries, and new market arrivals.
              </CardDescription>
            </CardHeader>
            <CardContent className="px-8 pb-8">
              <FormProvider formKey="join_neighborhood_form_home" formId="join_neighborhood_form_home" sectionName="newsletter-signup" defaultValues={{
              email: ""
            }} submitText="Sign Up" successMessage="Thank you for joining! We'll see you at the café soon.">
                <NewsletterFormInner />
              </FormProvider>
              <p className="text-xs text-center text-muted-foreground mt-6 font-default">
                By signing up, you agree to receive our latest news and special offers from M&M Café & Market.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}